module.exports = __webpack_public_path__ + "static/media/90.b236bea2.svg";